import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { Box, IconButton, TextField } from '@mui/material';
export default function HNumberStepperField({ value, min = 0, max = Number.MAX_VALUE, step = 1, onChange, disabled = false, textFieldProps, label, allowEmpty = false }) {
    const safeValue = Number.isFinite(value) ? value : 0;
    const allowNegative = min < 0;
    const handleIncrement = () => {
        onChange(Math.min(max, safeValue + step));
    };
    const handleDecrement = () => {
        onChange(Math.max(min, safeValue - step));
    };
    return (_jsx(TextField, { ...textFieldProps, variant: textFieldProps?.variant ?? 'outlined', type: 'number', label: label, value: allowEmpty && !Number.isFinite(value) ? '' : safeValue, disabled: disabled, onClick: (e) => e.stopPropagation(), onKeyDown: (e) => {
            if (['.', ',', 'e', 'E', '+'].includes(e.key) || (!allowNegative && e.key === '-')) {
                e.preventDefault();
            }
            textFieldProps?.onKeyDown?.(e);
        }, onChange: (e) => {
            const raw = e.target.value;
            if (raw === '') {
                onChange(allowEmpty ? Number.NaN : min);
                return;
            }
            const integerPattern = allowNegative ? /^-?\d+$/ : /^\d+$/;
            if (!integerPattern.test(raw)) {
                return;
            }
            const next = Number.parseInt(raw, 10);
            onChange(Number.isFinite(next) ? Math.min(max, Math.max(min, next)) : min);
        }, inputProps: {
            min,
            step: 1,
            inputMode: 'numeric',
            pattern: allowNegative ? '-?[0-9]*' : '[0-9]*'
        }, InputProps: {
            endAdornment: (_jsxs(Box, { onClick: (e) => e.stopPropagation(), sx: { display: 'flex', flexDirection: 'column', ml: 0.5, mr: -0.5 }, children: [_jsx(IconButton, { size: 'small', "aria-label": 'increment', onMouseDown: (e) => e.preventDefault(), onClick: handleIncrement, sx: { border: 'none', width: '10px', height: '10px' }, children: _jsx(KeyboardArrowUpIcon, { style: { width: '14px', height: '14px' } }) }), _jsx(IconButton, { size: 'small', "aria-label": 'decrement', onMouseDown: (e) => e.preventDefault(), onClick: handleDecrement, sx: { border: 'none', width: '10px', height: '10px' }, children: _jsx(KeyboardArrowDownIcon, { style: { width: '14px', height: '14px' } }) })] }))
        }, sx: {
            width: '100%',
            // Hide native browser spinners (we render custom arrows)
            '& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button': {
                WebkitAppearance: 'none',
                margin: 0
            },
            '& input[type=number]': {
                MozAppearance: 'textfield'
            },
            '& .MuiFilledInput-root': {
                backgroundColor: (theme) => theme.palette.common.grey8,
                borderRadius: '12px',
                pr: 1.5,
                '&:hover': {
                    backgroundColor: (theme) => theme.palette.common.grey8
                },
                '& fieldset': {
                    borderColor: (theme) => theme.palette.grey[300]
                },
                '&:hover fieldset': {
                    borderColor: (theme) => theme.palette.grey[400]
                },
                '&.Mui-focused fieldset': {
                    borderColor: (theme) => theme.palette.primary.main,
                    borderWidth: 1
                }
            },
            '& .MuiOutlinedInput-root': {
                backgroundColor: (theme) => theme.palette.common.grey8,
                borderRadius: '12px',
                '& fieldset': {
                    borderColor: (theme) => theme.palette.grey[300]
                },
                '&:hover fieldset': {
                    borderColor: (theme) => theme.palette.grey[400]
                },
                '&.Mui-focused fieldset': {
                    borderColor: (theme) => theme.palette.primary.main,
                    borderWidth: 1
                }
            }
        } }));
}
